import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company } from '../company/types';

export interface UploadFile {
  file: File;
  name: string;
  fiscalYear: string;
  fiscalQuarter: string;
  publishedAt: string;
  error?: string;
  status?: 'idle' | 'uploading' | 'success' | 'failed';
}

export interface DocumentUploadState {
  company: Company | null;
  category: string;
  type: string;
  files: UploadFile[];
  uploading: boolean;
}

const initialState: DocumentUploadState = {
  company: null,
  category: '',
  type: '',
  files: [],
  uploading: false,
};

const documentUploadSlice = createSlice({
  name: 'documentUpload',
  initialState,
  reducers: {
    setCompany(state, action: PayloadAction<Company | null>) {
      state.company = action.payload;
    },
    setCategory(state, action: PayloadAction<string>) {
      state.category = action.payload;
    },
    setType(state, action: PayloadAction<string>) {
      state.type = action.payload;
    },
    setFiles(state, action: PayloadAction<UploadFile[]>) {
      state.files = action.payload;
    },
    setUploading(state, action: PayloadAction<boolean>) {
      state.uploading = action.payload;
    },
    resetUploadState() {
      return initialState;
    },
  },
});

export const { setCompany, setCategory, setType, setFiles, setUploading, resetUploadState } =
  documentUploadSlice.actions;

export default documentUploadSlice.reducer;
